import React, { useState, useEffect } from 'react';
import Tab from "../components/tab";
import { useDispatch, useSelector } from 'react-redux';
import { 
    generate_my_cv,
    personal_information,
    Professional_summary,
    dispatchActivites,
    dispatchEducation,
    dispatchLanguage
  } from "../../../Redux/ActionCreator";
  import EditPersonal from '../edit/personal';
  import EditInterests from '../edit/Interest';
  import EditSummary from '../edit/summary';
  import EditExperience from '../edit/experience';
  import EditSkill from "../edit/skills"
  import EditSoftSkill from "../edit/skills-soft";
  import EditEducation from "../edit/education";
  import EditCert from "../edit/certification";
  import EditLanguage from '../edit/language';
  import { createPortal } from 'react-dom';
  import { ToastContainer, toast } from 'react-toastify';
  import { capitalize, capitalizeWords } from '../../../utils/capitalize/capitalizeWord';
  import ReactHtmlParser from 'react-html-parser'; 
  import { motion } from "framer-motion";
  import { Typewriter } from "react-simple-typewriter";
  import { extractLatestThreeExperiences } from '../../../utils/skillsService/index.js';

const ProfileSummary = ({ prevStep, nextStep, setStep }) => {
    const dispatch = useDispatch()
    let [ mappedExp, setMappedExp ] = useState([]);
    const activity = useSelector((act) => act.activities);
    const secret = useSelector((prev) => prev.secret);
    // const combine_skills = useSelector(e => e.combine_skills) || [];  
    const info = useSelector((info) => info.personal_info);
    const educ = useSelector(edu => edu.education);
    const prof_summary = useSelector((summary) => summary.summary);
    const language_data = useSelector((lan) => lan.language);
    const p_skills = useSelector((e) => e.p_skills);
    const Tech_skills = useSelector((e) => e.skills);
    const certifications = useSelector(e => e.cert);
    let YOF = useSelector(e => e.yof);
    const userInfo = useSelector((e) => e.userInfo);
    const flowLanguage = useSelector(e => e.t_lang.selected);
    const sidebar = useSelector(e => e.sidebarOpen.message);
    const profile = useSelector(e => e.profile);

    const [combine_skills, setCombine_skills] = useState([]);
    // console.log("showLanguageModal", showLanguageModal)
    const [ showPersonal, setShowPersonal ] = useState(false);
    const [ showInterest, setShowInterest ] = useState(false);
    const [ showSummary, setShowSummary ] = useState(false);
    const [ showExperience, setShowExperience ] = useState(false);
    const [ showSkills, setShowSkills ] = useState(false);
    const [ showSoftSkills, setShowSoftSkills ] = useState(false);
    const [ showEducation, setShowEducation ] = useState(false);
    const [ showCert, setShowCert ] = useState(false);
    const [ showLanguage, setShowLanguage ] = useState(false);

    useEffect(() => {
        if (Tech_skills?.skills !== null && p_skills?.p_skills != null) {
            setCombine_skills([...Tech_skills?.skills, ...p_skills?.p_skills])
        }
    }, [])

    useEffect(() => {
        // Function to strip HTML tags
        const stripHtmlTags = (html) => {
            const doc = new DOMParser().parseFromString(html, "text/html");
            return doc.body.textContent || ""; // Extract plain text
        };

        const convertAllDayToDayToArray = () => {
            let experience = activity.activities;
            if (experience !== null && typeof experience[0]?.Day_to_day_work == "string") {
                for (let exp of experience) {
                    if (typeof exp?.Day_to_day_work == "string") {
                        let stripedExp = stripHtmlTags(exp?.Day_to_day_work);
                        let newExp = stripedExp?.split(/(?<=\.)\s+(?=[A-Z])|•\s*(?=[A-Z])/); // ?.split(/(?<=[.•])\s*(?=[A-Z])/); // stripedExp?.split(/\.|•|-\s+(?=[A-Z])/); // pop remove the extra dots
                        if (newExp[newExp.length - 1] == "") newExp.pop();
                        exp.Day_to_day_work = newExp;
                        console.log("exp", exp?.Day_to_day_work);
                    }
                }
                // dispatch(dispatchActivites(experience));
                setMappedExp(experience);
            } else if (experience !== null && Array.isArray(experience[0]?.Day_to_day_work)) {
                setMappedExp(experience);
            }
        }
        convertAllDayToDayToArray();
    }, [showExperience]);
  
  // Handlers
  const handleEdit = (section) => {
    alert(`Edit ${section} section clicked!`);
    // In a real app, you might open a modal or navigate to a different form page
  };

    /* Moving section */
    const handlePrev = () => {
        prevStep();
    }

    const handleNextCall = async () => {
        try {
            // if (userInfo.user?.phone_number_verified !== true) {
            //     setTimeout(() => {
            //         toast.error("Verify your phone number.", {
            //           position: toast.POSITION.TOP_RIGHT,
            //         });
            //     }, 50);
            //     setShowPersonal(true);
            // } else 
            if (info.message?.JobInterests[0] == null) {
                setTimeout(() => {
                    toast.error("At least one job interests is needed.", {
                      position: toast.POSITION.TOP_RIGHT,
                    });
                }, 50);
                setShowInterest(true);
            } else {
                let credentials = {
                    Fullname:
                        info.message?.Firstname +
                        " " +
                        info.message?.LastName,
                    FirstName: info.message?.Firstname,
                    LastName: info.message?.LastName,
                    Email: info.message?.Email,
                    Phone_number: info.message?.Phone_number,
                    Address: info.message?.Address,
                    Professional_summary: prof_summary.summary,
                    Education: educ.education,
                    Experience: activity.activities,
                    Technical_skills: Tech_skills?.skills?.slice(1, 9)?.map(e => (e?.value !== undefined ? capitalizeWords(e?.value?.toLowerCase()) : capitalizeWords(e?.toLowerCase()))), //data.get('technical_skills'),
                    Personal_skills: p_skills?.p_skills?.slice(1, 8)?.map(e => (e?.value !== undefined ? capitalizeWords(e?.value?.toLowerCase()) : capitalizeWords(e?.toLowerCase()))), //data.get('personal_skills'),
                    // Volunteer: voluteer.voluntary,
                    // Reference: reference.ref || [],
                    Language: language_data.lang, //data.get('language'),
                    CvType: info.message?.JobInterests[0],
                    JobInterests: info.message?.JobInterests,
                    Lang: ["English"], // the resume lang either in spanish or in English
                    // Award: awd,
                    year_of_experience: YOF.message,
                    certification: certifications.cert
                };

                let finalExp;
                if (profile.message !== null && profile.message?.Experience != null) {
                    finalExp = [...profile.message?.Experience, ...activity.activities];
                } else {
                    finalExp = activity.activities;
                }
                console.log("finalExp", finalExp);

                dispatch(
                  extractLatestThreeExperiences(
                    finalExp,
                    "auto-save"
                  )
                );

                dispatch(generate_my_cv(credentials));
                nextStep();
            }
            
        } catch (error) {
            throw error
        }
    }



  let personalModal = showPersonal ? createPortal(
    <div className="top-0 left-0 fixed bottom-0 right-0 z-10 h-screen flex justify-center items-center md:bg-black md:bg-opacity-70 backdrop-blur-[2px] sm:bg-white xsm:bg-white overflow-y-scroll ScrollOnly">
      <EditPersonal handleClick={() => setShowPersonal(false)} back="/generateCV" />
    </div>, document.getElementById("modal")
  ) : null;
  
  let interestModal = showInterest ? createPortal(
    <div className="top-0 left-0 fixed bottom-0 right-0 z-10 h-screen flex justify-center items-center md:bg-black md:bg-opacity-70 backdrop-blur-[2px] sm:bg-white xsm:bg-white">
      <EditInterests handleClick={() => setShowInterest(false)} back="/generateCV" />
    </div>, document.getElementById("modal")
  ) : null;

  let summaryModal = showSummary ? createPortal(
    <div className="top-0 left-0 fixed bottom-0 right-0 z-10 h-screen flex justify-center items-center md:bg-black md:bg-opacity-70 backdrop-blur-[2px] sm:bg-white xsm:bg-white">
      <EditSummary handleClick={() => setShowSummary(false)} back="/generateCV" />
    </div>, document.getElementById("modal")
  ) : null;

  let experienceModal = showExperience ? createPortal(
    <div className="top-0 left-0 fixed bottom-0 right-0 z-1 h-screen flex justify-center items-center md:bg-black md:bg-opacity-70 backdrop-blur-[2px] sm:bg-white xsm:bg-white overflow-y-scroll ScrollOnly">
      <EditExperience handleClick={() => setShowExperience(false)} back="/generateCV" />
    </div>, document.getElementById("modal")
  ) : null;

  let skillModal = showSkills ? createPortal(
    <div className="top-0 left-0 fixed bottom-0 right-0 z-1 h-screen flex justify-center items-center md:bg-black md:bg-opacity-70 backdrop-blur-[2px] sm:bg-white xsm:bg-white overflow-y-scroll ScrollOnly">
      <EditSkill handleClick={() => setShowSkills(false)} back="/generateCV" />
    </div>, document.getElementById("modal")
  ) : null;

  let skillSoftModal = showSoftSkills ? createPortal(
    <div className="top-0 left-0 fixed bottom-0 right-0 z-1 h-screen flex justify-center items-center md:bg-black md:bg-opacity-70 backdrop-blur-[2px] sm:bg-white xsm:bg-white overflow-y-scroll ScrollOnly">
      <EditSoftSkill handleClick={() => setShowSoftSkills(false)} back="/generateCV" />
    </div>, document.getElementById("modal")
  ) : null;

  let educationModal = showEducation ? createPortal(
    <div className="top-0 left-0 fixed bottom-0 right-0 z-1 h-screen flex justify-center items-center md:bg-black md:bg-opacity-70 backdrop-blur-[2px] sm:bg-white xsm:bg-white overflow-y-scroll ScrollOnly">
      <EditEducation handleClick={() => setShowEducation(false)} back="/generateCV" />
    </div>, document.getElementById("modal")
  ) : null;

  let certModal = showCert ? createPortal(
    <div className="top-0 left-0 fixed bottom-0 right-0 z-1 h-screen flex justify-center items-center md:bg-black md:bg-opacity-70 backdrop-blur-[2px] sm:bg-white xsm:bg-white overflow-y-scroll ScrollOnly">
      <EditCert handleClick={() => setShowCert(false)} back="/generateCV" />
    </div>, document.getElementById("modal")
  ) : null;

  let languageModal = showLanguage ? createPortal(
    <div className="top-0 left-0 fixed bottom-0 right-0 z-1 h-screen flex justify-center items-center md:bg-black md:bg-opacity-70 backdrop-blur-[2px] sm:bg-white xsm:bg-white overflow-y-scroll ScrollOnly">
      <EditLanguage handleClick={() => setShowLanguage(false)} back="/generateCV" />
    </div>, document.getElementById("modal")
  ) : null;

  const handlePersonalInfo = () => {
    let data = { ...info.message, personalReviewed: true }
    dispatch(personal_information(data));
  }

  const handleInterestInfo = () => {
    let data = { ...info.message, interestsReviewed: true }
    dispatch(personal_information(data));
  }

  const handleSummaryInfo = () => {
    let data = { ...info.message, summaryReviewed: true }
    dispatch(personal_information(data));
  }

  const handleExperienceInfo = () => {
    let data = { ...info.message, experienceReviewed: true }
    dispatch(personal_information(data));
  }

  const handleLangaugeInfo = () => {
    let data = { ...info.message, languageReviewed: true }
    dispatch(personal_information(data));
  }

  const handleEducationInfo = () => {
    let data = { ...info.message, educationReviewed: true }
    dispatch(personal_information(data));
  }

  const handleCertificationInfo = () => {
    let data = { ...info.message, certificationReviewed: true }
    dispatch(personal_information(data));
  }
  
  return (
    <>
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly h-fit flex justify-center ">
      <div className={`bg-[#FAFAFA] ${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-6 md:gap-y-16 lg:gap-0 lg:h-full flex flex-col lg:justify-between rounded-lg p-6 md:p-8`}>
        {/* Progress Indicator */}
        <div className="flex justify-center w-full my-4">
          <div className="tabarea gap-x-0 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <div className="vsm:hidden md:inline">
              <Tab
                label="Personal Information"
                current={false}
                completed={true}
                num="1"
              />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="2" current={false} label="Experience" completed={true} />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="3" current={false} label="Skills" completed={true} />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="4" current={false} label="Language" completed={true} />
            </div>
            <Tab num="4" current={false} label="Education" completed={true} />
            <Tab num="5" current={false} label="Professional Summary" completed={true} />
          </div>
        </div>

        {/* Title and Subtitle */}
        <h2 className="text-xl lg:text-2xl text-center text-[#5843BD] font-semibold my-2 notranslate" >
            {profile.message !== null && profile.message?.CompletionPercentage >= 95 ? (
                <>{flowLanguage == "Spanish" ? (
                    "Aquí está lo que capturamos de tu currículum:"
                ) : (
                    "Here is what we cature from your resume:"
                )}</>
            ) : (
                <>{flowLanguage == "Spanish" ? (
                    "¡Eso es todo! Tu perfil está casi listo. Antes de finalizar:"
                ) : (
                    "That’s it! Your profile is almost ready. Before we wrap up:"
                )}</>
            )}
        </h2>
        <p className="text-center text-gray-600 mb-8 notranslate" >
            {flowLanguage == "Spanish" ? (
                `Aquí tienes un resumen de tu ${profile.message !== null && profile.message?.CompletionPercentage >= 95 ? "currículum" : "perfil"} . Haz clic en los botones de edición para actualizar cualquier sección.`
            ) : (
                `Here is a summary of your ${profile.message !== null && profile.message?.CompletionPercentage >= 95 ? "resume" : "profile"} . Click on the edit buttons to update any section.`
            )}
            <br />
            {flowLanguage == "Spanish" ? (
                "Una vez que hayas revisado todo, haz clic en \"Completar\" en la parte inferior de la página."
            ) : (
                "Once done reviewing, click “Complete” at the bottom of the page."
            )}
        </p>

        {/* Personal Details */}
        <motion.section 
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
            className="border rounded-md p-4 md:mb-6 bg-[#FFFFFFCC] shadow-md"
        >
            <div className="flex items-center justify-between mb-2">
                <h3 className="text-lg font-semibold text-[#5843BD]">Personal Details</h3>
                <button
                    onClick={() => setShowPersonal(true)}
                    className="text-sm bg-[#5843BD] text-white rounded-lg py-2 px-4"
                >
                    Edit
                </button>
            </div>

            {showPersonal !== true && (
                <>
                <div className='md:flex md:justify-between my-2'>
                    <div>
                        <p className='text-lg text-[#00000080] py-2 font-small'>Name</p>
                        <p className="mb-1 notranslate">
                            {info.message?.Firstname + " " + info.message?.LastName}
                        </p>
                    </div>
                    <div>
                        <p className='text-lg text-[#00000080] py-2 font-small  md:text-end'>Location</p>
                        <p className="mb-1 md:text-end">
                            {info.message?.Address}
                        </p>
                    </div>
                </div>
                
                <div className='md:flex md:justify-between my-2'>
                    <div>
                        <p className='text-lg text-[#00000080] py-2 font-small'>Phone number</p>
                        <p className="mb-1">
                            {info.message?.Phone_number}
                        </p>
                    </div>
                    <div>
                        <p className='text-lg text-[#00000080] py-2 font-small md:text-end'>Email address</p>
                        <p className="mb-1 md:text-end">
                            {info.message?.Email}
                        </p>
                    </div>
                </div>
                </>
            )}

        </motion.section>

        { info.message?.personalReviewed == undefined ? (
            <motion.div            
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.7 }}
            className='p-4 mt-[-15px]w-full flex justify-center '>
                <div className=' md:w-[500px] '>
                    <p className='text-center text-xs text-[#34A853]'>If you are satisfied with the information in this section, click the button below, otherwise, click on “Edit” and  make needed changes.
                    </p>                   
                        <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center mt-4">
                            <div className="flex justify-center lg:max-w-[90vw] w-full">                        
                            <button
                                onClick={handlePersonalInfo}
                                className="bg-[#34A853] flex items-center gap-x-3 text-white font-medium py-3 px-4 rounded-md"
                            >
                                <span className="notranslate text-xs" key={flowLanguage}>
                                    {flowLanguage == "Spanish" ? (
                                        "GUARDAR"
                                    ) : (
                                        "CORRECT, NEXT"
                                    )}
                                </span>
                                <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 8.5L3.5 6L8.5 11L18.5 1L21 3.5L8.5 16L1 8.5Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
            
                        </div>
                    </div>
                </div>
            </motion.div>
        ) : null}

        {/* Job Interests */}
        {info.message?.personalReviewed !== undefined && (
        <motion.section 
        initial={{ opacity: 0, y: 50 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
        className="border rounded-md p-4 md:mb-6 bg-[#FFFFFFCC] shadow-md">
            <div className="flex items-center justify-between mb-2">
                <h3 className="text-lg font-semibold text-[#5843BD]" >Job Interests</h3>
                <button
                    onClick={() => setShowInterest(true)}
                    className="text-sm bg-[#5843BD] text-white rounded-lg py-2 px-4"
                >
                    Edit
                </button>
            </div>
            {showInterest !== true && (
                <>
                {info.message?.JobInterests?.map((e, key) => (
                    <div className='py-2' key={key}>
                        <p className='text-md text-[#00000080] font-small'>{e !== "" && e !== undefined ? `Job title: ${key + 1}` : null}</p>
                        <p  className='text-md text-black font-small' >{e?.value !== undefined ? e?.value : e }</p>
                    </div>
                ))}
                </>
            )}
        </motion.section>
        )}

        { info.message?.personalReviewed !== undefined && info.message?.interestsReviewed == undefined ? (
            <motion.div            
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.7 }}
            className='p-4 mt-[-15px]w-full flex justify-center '>
                <div className=' md:w-[500px] '>
                    <p className='text-center text-xs text-[#34A853]'>If you are satisfied with the information in this section, click the button below, otherwise, click on “Edit” and  make needed changes.
                    </p>                   
                        <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center mt-4">
                            <div className="flex justify-center lg:max-w-[90vw] w-full">                        
                            <button
                                onClick={handleInterestInfo}
                                className="bg-[#34A853] flex items-center gap-x-3 text-white font-medium py-3 px-4 rounded-md"
                            >
                                <span className="notranslate text-xs" key={flowLanguage}>
                                    {flowLanguage == "Spanish" ? (
                                        "GUARDAR"
                                    ) : (
                                        "CORRECT, NEXT"
                                    )}
                                </span>
                                <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 8.5L3.5 6L8.5 11L18.5 1L21 3.5L8.5 16L1 8.5Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
            
                        </div>
                    </div>
                </div>
            </motion.div>            
        ) : null}

        {/* Professional Summary */}
        {info.message?.interestsReviewed !== undefined && (
            <motion.section 
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
            className="border rounded-md p-4 md:mb-6 bg-[#FFFFFFCC] shadow-md">
                <div className="flex items-center justify-between mb-2">                
                <h3 className="text-lg font-semibold text-[#5843BD]">Professional Summary</h3>
                <button
                    onClick={() => setShowSummary(true)}
                    className="text-sm bg-[#5843BD] text-white rounded-lg py-2 px-4"
                >
                    Edit
                </button>
                </div>
                
                <h6 className='text-md text-[#00000080] font-base mb-2'>Work Experience</h6>
                <p className='text-md text-black font-small mb-2' >{YOF.message}+ Work Experience</p>
                {showSummary !== true && (
                    <p className='text-md text-black font-small'>{ReactHtmlParser(prof_summary.summary)}</p>
                )}
            </motion.section>
        )}

        { info.message?.interestsReviewed !== undefined && info.message?.summaryReviewed == undefined ? (
            <motion.div            
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.7 }}
            className='p-4 mt-[-15px]w-full flex justify-center '>
                <div className=' md:w-[500px] '>
                    <p className='text-center text-xs text-[#34A853]'>If you are satisfied with the information in this section, click the button below, otherwise, click on “Edit” and  make needed changes.
                    </p>                   
                        <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center mt-4">
                            <div className="flex justify-center lg:max-w-[90vw] w-full">                        
                            <button
                                onClick={handleSummaryInfo}
                                className="bg-[#34A853] flex items-center gap-x-3 text-white font-medium py-3 px-4 rounded-md"
                            >
                                <span className="notranslate text-xs" key={flowLanguage}>
                                    {flowLanguage == "Spanish" ? (
                                        "GUARDAR"
                                    ) : (
                                        "CORRECT, NEXT"
                                    )}
                                </span>
                                <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 8.5L3.5 6L8.5 11L18.5 1L21 3.5L8.5 16L1 8.5Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
            
                        </div>
                    </div>
                </div>
            </motion.div>
        ) : null}


        {/* Work Experience */}
        {info.message?.summaryReviewed !== undefined  && (
            <motion.section 
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
            className="border rounded-md p-4 md:mb-6 bg-[#FFFFFFCC] shadow-md">
                <div className="flex items-center justify-between mb-2">
                <h3 className="text-lg font-semibold text-[#5843BD]">Work Experience</h3>
                <button
                    onClick={() => setShowExperience(true)}
                    className="text-sm bg-[#5843BD] text-white rounded-lg py-2 px-4"
                >
                    Edit
                </button>
                </div>
                {showExperience !== true && (
                    <>
                    {mappedExp?.map((exp, key) => (
                        <div key={key} >
                            <div className="md:flex md:items-start mb-2">
                                <div className='md:w-[20%] w-full md:my-0 vsm:my-2'>
                                    <p className="font-medium text-md">
                                        {exp?.Work_start_date} - {exp?.Work_end_date}
                                    </p>
                                    <p className="font-medium text-md notranslate">
                                        {exp?.Where_i_worked}
                                    </p>
                                </div>
                                <div className='w-full md:max-w-[75%] md:pl-6'>
                                    <p className="text-gray-700 text-md">{exp?.My_job_title}</p>
                                    <ul className="ml-4 ">
                                    {Array.isArray(exp?.Day_to_day_work) == true ? (
                                        <>
                                        {exp?.Day_to_day_work?.map((exp, key) => (
                                            <div key={key}>
                                            {exp[0] === "-" || exp[0] == "•" || exp[0] == "," ? (
                                                <li className="md:ml-[12px] md:ml-0 list-disc text-md">{ReactHtmlParser(exp.slice(1, exp?.length))}</li>
                                            ) : (
                                                <>
                                                {/^\d\./.test(exp) == true ? (
                                                    <li className="md:ml-[12px] md:ml-0 list-disc text-md">{ReactHtmlParser(exp.slice(2, exp?.length))}</li>
                                                ) : (
                                                    <li className="md:ml-[12px] md:ml-0 list-disc text-md">{ReactHtmlParser(exp) || null}</li>
                                                )
                                                }
                                                </>
                                            )}
                                            </div>
                                        ))}
                                        </>
                                    ) : (
                                        <>
                                        <li className="ml-[12px] md:ml-0 list-disc text-md" key={key}>{ReactHtmlParser(exp?.Day_to_day_work)}</li>
                                        </>
                                    )}
                                    </ul>
                                </div>
                            </div>
                            
                            {activity.activities[key + 1] !== undefined ? 
                                <hr className='my-3'></hr> : null}
                        </div>
                    ))}
                    </>
                )}
            </motion.section>
        )}

        { info.message?.summaryReviewed !== undefined && info.message?.experienceReviewed == undefined ? (
            <motion.div            
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.7 }}
            className='p-4 mt-[-15px]w-full flex justify-center '>
                <div className=' md:w-[500px] '>
                    <p className='text-center text-xs text-[#34A853]'>If you are satisfied with the information in this section, click the button below, otherwise, click on “Edit” and  make needed changes.
                    </p>                   
                        <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center mt-4">
                            <div className="flex justify-center lg:max-w-[90vw] w-full">                        
                            <button
                                onClick={handleExperienceInfo}
                                className="bg-[#34A853] flex items-center gap-x-3 text-white font-medium py-3 px-4 rounded-md"
                            >
                                <span className="notranslate text-xs" key={flowLanguage}>
                                    {flowLanguage == "Spanish" ? (
                                        "GUARDAR"
                                    ) : (
                                        "CORRECT, NEXT"
                                    )}
                                </span>
                                <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 8.5L3.5 6L8.5 11L18.5 1L21 3.5L8.5 16L1 8.5Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
            
                        </div>
                    </div>
                </div>
            </motion.div>
        ) : null}


        {/* Skills */}
        {info.message?.experienceReviewed !== undefined  && (
            <motion.section 
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
            className="border rounded-md p-4 md:mb-6 bg-[#FFFFFFCC] shadow-md">
                <div className="flex items-center justify-between mb-2">
                <h3 className="text-lg font-semibold text-[#5843BD]">Your Skills</h3>
                <button
                    onClick={() => setShowSkills(true)}
                    className="text-sm bg-[#5843BD] text-white rounded-lg py-2 px-4"
                >
                    Edit
                </button>
                </div>
                <div className="flex flex-wrap gap-2 max-w-[90%] px-4">
                {showSkills !== true && (
                    <>
                    {Tech_skills?.skills?.map((skill, idx) => (
                        <span
                        key={idx}
                        className="bg-black text-white rounded-full text-sm p-3 rounded-md text-center"
                        >
                            {skill?.value !== undefined ? skill?.value : skill}
                        </span>
                    ))}
                    </>
                )}
                </div>
            </motion.section>
        )}

        {info.message?.experienceReviewed !== undefined  && (
            <motion.section 
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
            className="border rounded-md p-4 md:mb-6 bg-[#FFFFFFCC] shadow-md">
                <div className="flex items-center justify-between mb-2">
                <h3 className="text-lg font-semibold text-[#5843BD]">Your Soft Skills</h3>
                <button
                    onClick={() => setShowSoftSkills(true)}
                    className="text-sm bg-[#5843BD] text-white rounded-lg py-2 px-4"
                >
                    Edit
                </button>
                </div>
                <div className="flex flex-wrap gap-2 max-w-[90%] px-4">
                    {showSoftSkills !== true && (
                        <>
                        {p_skills?.p_skills?.map((skill, idx) => (
                            <span
                            key={idx}
                            className="bg-black text-white rounded-full text-sm p-3 rounded-md text-center"
                            >
                                {skill?.value !== undefined ? skill?.value : skill}
                            </span>
                        ))}
                        </>
                    )}
                </div>
            </motion.section>
        )}


        {/* Languages */}
        {info.message?.experienceReviewed !== undefined  && (
            <motion.section 
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
            className="border rounded-md p-4 md:mb-6 bg-[#FFFFFFCC] shadow-md">
                <div className="flex items-center justify-between mb-2">
                <h3 className="text-lg font-semibold text-[#5843BD]">Languages</h3>
                <button
                    onClick={() => setShowLanguage(true)}
                    className="text-sm bg-[#5843BD] text-white rounded-lg py-2 px-4"
                >
                    Edit
                </button>
                </div>
                {language_data?.lang?.length !== 0 && language_data.lang?.map((e, key) => (
                    <p key={key}>{e?.language} - {e?.rate}</p>
                ))}
            </motion.section>
        )}

        { info.message?.experienceReviewed !== undefined && info.message?.languageReviewed == undefined ? (
            <motion.div            
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.7 }}
            className='p-4 mt-[-15px]w-full flex justify-center '>
                <div className=' md:w-[500px] '>
                    <p className='text-center text-xs text-[#34A853]'>If you are satisfied with the information in this section, click the button below, otherwise, click on “Edit” and  make needed changes.
                    </p>                   
                        <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center mt-4">
                            <div className="flex justify-center lg:max-w-[90vw] w-full">                        
                            <button
                                onClick={handleLangaugeInfo}
                                className="bg-[#34A853] flex items-center gap-x-3 text-white font-medium py-3 px-4 rounded-md"
                            >
                                <span className="notranslate text-xs" key={flowLanguage}>
                                    {flowLanguage == "Spanish" ? (
                                        "GUARDAR"
                                    ) : (
                                        "CORRECT, NEXT"
                                    )}
                                </span>
                                <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 8.5L3.5 6L8.5 11L18.5 1L21 3.5L8.5 16L1 8.5Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
            
                        </div>
                    </div>
                </div>
            </motion.div>
        ) : null}

        {/* Education */}
        {info.message?.languageReviewed !== undefined && (
            <motion.section 
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
            className="border rounded-md p-4 md:mb-6 bg-[#FFFFFFCC] shadow-md"
        >
            <div className="flex items-center justify-between mb-2">
            <h3 className="text-lg font-semibold text-[#5843BD]">Education</h3>
            <button
                onClick={() => setShowEducation(true)}
                className="text-sm bg-[#5843BD] text-white rounded-lg py-2 px-4"
            >
                Edit
            </button>
            </div>
            {showEducation !== true && (
                <>
                {educ.education?.map((edu, idx) => (
                <div key={idx}>
                    <div className="md:flex md:items-start mb-2" key={idx} >
                        <div className='w-[200px]'>
                            <p className="font-medium">
                                {edu?.End_date}
                            </p>
                        </div>
                        <div>
                            <p className="text-gray-700 text-md">{edu?.Degree} {edu?.Course}</p>
                            <p className="text-gray-700 text-md notranslate">{edu?.School}</p>
                        </div>
                    </div>
                    
                    {educ.education[idx + 1] !== undefined ? 
                    <hr className='my-3'></hr> : null}
                </div>
                ))}
                </>
            )}
        </motion.section>
        )}

        { info.message?.languageReviewed !== undefined && info.message?.educationReviewed == undefined ? (
            <motion.div            
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.7 }}
            className='p-4 mt-[-15px]w-full flex justify-center '>
                <div className=' md:w-[500px] '>
                    <p className='text-center text-xs text-[#34A853]'>If you are satisfied with the information in this section, click the button below, otherwise, click on “Edit” and  make needed changes.
                    </p>                   
                        <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center mt-4">
                            <div className="flex justify-center lg:max-w-[90vw] w-full">                        
                            <button
                                onClick={handleEducationInfo}
                                className="bg-[#34A853] flex items-center gap-x-3 text-white font-medium py-3 px-4 rounded-md"
                            >
                                <span className="notranslate text-xs" key={flowLanguage}>
                                    {flowLanguage == "Spanish" ? (
                                        "GUARDAR"
                                    ) : (
                                        "CORRECT, NEXT"
                                    )}
                                </span>
                                <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 8.5L3.5 6L8.5 11L18.5 1L21 3.5L8.5 16L1 8.5Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
            
                        </div>
                    </div>
                </div>
            </motion.div>
        ) : null}

        {/* Certifications */}
        {info.message?.educationReviewed !== undefined  && (
            <motion.section 
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
            className="border rounded-md p-4 mb-6 bg-[#FFFFFFCC] shadow-md">
                <div className="flex items-center justify-between mb-2">
                <h3 className="text-lg font-semibold text-[#5843BD]">Certifications</h3>
                <button
                    onClick={() => setShowCert(true)}
                    className="text-sm bg-[#5843BD] text-white rounded-lg py-2 px-4"
                >
                    Edit
                </button>
                </div>
                {showCert !== true && (
                    <>
                        {certifications.cert?.map((cert, idx) => (
                        <p key={idx} className="mb-2">
                            <span className="font-medium">{cert}</span>
                        </p>
                        ))}
                    </>
                )}
            </motion.section>
        )}

        { info.message?.educationReviewed !== undefined && info.message?.certificationReviewed == undefined ? (
            <motion.div            
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.7 }}
            className='p-4 mt-[-15px]w-full flex justify-center '>
                <div className=' md:w-[500px] '>
                    <p className='text-center text-xs text-[#34A853]'>If you are satisfied with the information in this section, click the button below, otherwise, click on “Edit” and  make needed changes.
                    </p>                   
                        <div className="flex lg:w-full w-full flex-col lg:flex-row md:gap-8 md:justify-between justify-center mt-4">
                            <div className="flex justify-center lg:max-w-[90vw] w-full">                        
                            <button
                                onClick={handleCertificationInfo}
                                className="bg-[#34A853] flex items-center gap-x-3 text-white font-medium py-3 px-4 rounded-md"
                            >
                                <span className="notranslate text-xs" key={flowLanguage}>
                                    {flowLanguage == "Spanish" ? (
                                        "GUARDAR"
                                    ) : (
                                        "CORRECT, NEXT"
                                    )}
                                </span>
                                <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 8.5L3.5 6L8.5 11L18.5 1L21 3.5L8.5 16L1 8.5Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
            
                        </div>
                    </div>
                </div>
            </motion.div>
        ) : null}

        {/* Footer Buttons */}
        {info.message?.experienceReviewed !== undefined  && info.message?.educationReviewed !== undefined  && info.message?.personalReviewed !== undefined && (
            <div className="flex justify-center w-full">
                <div className="flex justify-end lg:max-w-[90%] w-full">
                    {/* <button
                        onClick={handlePrev}
                        className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 md:px-8 px-4 rounded-md"
                    >
                        <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        PREVIOUS
                    </button> */}
                    {/* <div></div> */}
                    
                    <button
                        onClick={handleNextCall}
                        className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 md:px-6 px-4 rounded-md notranslate"
                    >
                        {flowLanguage == "Spanish" ? (
                        "COMPLETO"
                        ) : (
                        "COMPLETE"
                        )} 
                        <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>

                </div>
            </div>
        )}
            
            
        </div>
        <ToastContainer />
    </div>
    {personalModal}
    {interestModal}
    {summaryModal}
    {experienceModal}
    {skillModal}
    {skillSoftModal}
    {educationModal}
    {languageModal}
    {certModal}
    </>
  );
};

export default ProfileSummary;
